<div class="form-container">
    <aum-input [aumFormControl]="headerCaptionControl" floatLabel="auto" [simpleInput]="true"> </aum-input>
    <div class="form-container__actions">
        <button
            mat-icon-button
            class="form-container__actions--save"
            (click)="onSaveHeaderCaption()"
            [disabled]="headerCaptionControl.invalid"
        >
            <mat-icon svgIcon="save"></mat-icon>
        </button>

        <mat-icon class="form-container__actions--noaction" svgIcon="close" (click)="onCancel()"></mat-icon>
    </div>
</div>
